import React from 'react';
import PropTypes from 'prop-types';
import siteStructure from '../../data/siteStructure';

const AccountMenu = ({ active, billingEnabled }) => {
  return (
    <ul className="inline-list-lg">
      {siteStructure
        .filter(item => item.parentId === `account`)
        .filter((item) => {
          // We do not equals to as billingEnabled could be undefined
          if (billingEnabled !== true) {
            switch (item.id) {
              case `plan`:
              case `billing`:
              case `payment-history`:
                return null;
              // no default
            }
          }
          return item;
        })
        .map((item) => {
          const { id, href, title } = item;
          return (
            <li key={id} className={active === id ? `active` : ``}>
              <a href={href}>{title}</a>
            </li>
          );
        })
      }
    </ul>
  );
};

AccountMenu.propTypes = {
  active: PropTypes.string.isRequired,
  billingEnabled: PropTypes.bool,
};

export default AccountMenu;


// WEBPACK FOOTER //
// ./library/app/components/Account/AccountMenu.js